import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Handshake, Zap, RefreshCcw } from 'lucide-react';
export function WhyTalvori() {
  const features = [{
    icon: <ShieldCheck className="w-6 h-6 text-white" data-id="element-311" />,
    title: 'Carefully Vetted Talent',
    desc: 'Rigorous screening for technical skills, English proficiency, and cultural alignment.'
  }, {
    icon: <Handshake className="w-6 h-6 text-white" data-id="element-312" />,
    title: 'Personalized Partnership',
    desc: 'We take the time to deeply understand your business, culture, and specific needs.'
  }, {
    icon: <Zap className="w-6 h-6 text-white" data-id="element-313" />,
    title: 'Faster Hiring Process',
    desc: 'Streamlined workflows that deliver high-quality candidates in days, not months.'
  }, {
    icon: <RefreshCcw className="w-6 h-6 text-white" data-id="element-314" />,
    title: 'Replacement Guarantee',
    desc: "Peace of mind with our 90-day guarantee. If it's not a fit, we replace at no cost."
  }];
  const metrics = ['5–10 Days to Shortlist', '2–3 Weeks to Hire', '90-Day Guarantee', 'Founder-Led Approach'];
  return <section id="services" className="py-24 bg-navy relative overflow-hidden" data-id="element-315">
      {/* Background Glow */}
      <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-brand-gradient rounded-full blur-[120px] opacity-20 translate-x-1/3 -translate-y-1/3 pointer-events-none" data-id="element-316" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-317">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-318">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-319">
            A More{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple via-pink to-coral" data-id="element-320">
              Strategic Way
            </span>{' '}
            to Hire
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-slate-300" data-id="element-321">
            We focus on quality, fit, and long-term success.
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-16" data-id="element-322">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 p-8 rounded-3xl backdrop-blur-sm hover:bg-white/10 transition-colors" data-id="element-323">
              <div className="w-12 h-12 rounded-2xl bg-white/10 flex items-center justify-center mb-6" data-id="element-324">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold mb-3 text-white" data-id="element-325">
                {feature.title}
              </h3>
              <p className="text-slate-300 leading-relaxed" data-id="element-326">{feature.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="border-t border-white/10 pt-10" data-id="element-327">
          <div className="flex flex-wrap justify-center gap-x-12 gap-y-6" data-id="element-328">
            {metrics.map((metric, index) => <div key={index} className="flex items-center gap-3 text-white font-medium" data-id="element-329">
                <div className="w-2 h-2 rounded-full bg-coral" data-id="element-330" />
                {metric}
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}